import React, { useState, useEffect } from "react";
import EventDetails from "./EventDetails";
import { Col, Container, Row } from "react-bootstrap";
import RsvpFormModal from "../../event-rsvp/components/RsvpFormModal";
import { isFutureDate } from "../../../hooks/useCheckEventDate";
import EventHappenedInPast from "../../event-rsvp/components/EventHappenedInPast";
import { constants } from "../../../constants/constants";















/**
 * A function component that renders a section that contains the event details
 * and the RSVP form. The section is divided into two columns, with the event
 * details on the left and the RSVP form on the right. The event details are
 * rendered using the EventDetails component and the RSVP form is rendered using
 * the RsvpFormModal component. If the event date is in the future, the RSVP form
 * is displayed, otherwise an event happened in the past message is displayed.
 * @returns {ReactElement} A JSX element representing the section that contains
 * the event details and the RSVP form.
 */

export default function EventDetailsAndRSVP() {



  const [title, setTitle] = useState("Eraconneckt Open Forum | Eraconneckt");

  useEffect(() => {
    document.title = title;
    setTitle(title);
  }, [title]);


  const {
    OPEN_FORUM_EVENT_DATE
  } = constants()

  /**
   * Determines if the open forum event is in the future by comparing the event date
   * with the current date. Uses the isFutureDate utility function to make this comparison.
   * @constant {boolean} isFutureEvent - True if the event date is in the future, false otherwise
   */
  const isFutureEvent = isFutureDate(new Date(OPEN_FORUM_EVENT_DATE).getDate());


  return (
    <>
      <section
        className="event-details-and-rsvp"
        id="event-details-and-rsvp"
      >
        <Container
          style={{
            marginTop: "7.5rem"
          }}
        >
          <Row>
            <Col
              xs={{ span: 12, order: 1 }}
              md={{ span: 12, order: 1 }}
              lg={{ span: 7, order: 1 }}
            >
              <EventDetails />
            </Col>
            <Col
              xs={{ span: 12, order: 2 }}
              md={{ span: 12, order: 2 }}
              lg={{ span: 5, order: 2 }}
            >
              <div
                style={{
                  marginTop: "3.75rem",
                }}
              >
                {
                  isFutureEvent
                    ?
                    <RsvpFormModal />
                    :
                    <EventHappenedInPast />

                }
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}





